import { Skeleton } from '@material-ui/lab';
import type { ComponentPropsWithoutRef, FC } from 'react';
import { useState } from 'react';

export interface MediaDisplayProps extends ComponentPropsWithoutRef<'img'> {
  name: string;
  url: string;
  mimeType: string;
}

export const MediaDisplay: FC<MediaDisplayProps> = ({
  name,
  url,
  mimeType,
  alt,
  ...restProps
}) => {
  const isVideo = mimeType.includes('video');
  const [loaded, setLoaded] = useState(false);

  return (
    <>
      {isVideo ? (
        <video className="rounded-t-lg object-cover w-60 h-60" src={url} loop />
      ) : (
        <>
          <img
            style={loaded ? {} : { display: 'none' }}
            alt={alt}
            onLoad={() => setLoaded(true)}
            src={url}
            {...restProps}
          />
          {!loaded ? (
            <Skeleton variant="rect" height={240} width={240} />
          ) : (
            <></>
          )}
        </>
      )}
    </>
  );
};
